import moment from 'moment'
import {
  filterStatusDateFormat,
  filterStatusMonthDateFormat,
  filterStatusYearMonthDateFormat,
} from '../../configuration/configs'

export function getFormattedDateForFilterStatus(startDateFilter, endDateFilter) {
  if (!startDateFilter) return null

  const DATE = filterStatusDateFormat
  const MONTH_DATE = filterStatusMonthDateFormat
  const YEAR_MONTH_DATE = filterStatusYearMonthDateFormat

  const startDate = moment(startDateFilter)
  const endDate = moment(endDateFilter)

  if (!endDateFilter || startDate.isSame(endDate, 'day')) {
    return startDate.format(MONTH_DATE)
  }

  if (!startDate.isSame(endDate, 'year')) {
    return `${startDate.format(YEAR_MONTH_DATE)} - ${endDate.format(YEAR_MONTH_DATE)}`
  } else if (startDate.isSame(endDate, 'month')) {
    return `${startDate.format(MONTH_DATE)} - ${endDate.format(DATE)}`
  } else {
    return `${startDate.format(MONTH_DATE)} - ${endDate.format(MONTH_DATE)}`
  }
}
